import React, { Component } from 'react';
import { LookBook } from '../../library/LookBook';
import './Categories.css';
import Subcategories from '../Subcategories/Subcategories';
import CategoryModal from '../CategoryModal/CategoryModal';
import { BackLink } from '../../library/BackLink';
import lodashGet from 'lodash.get';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  FormGroup,
  Input,
  Label,
  FormText
} from 'reactstrap';
import classnames from 'classnames';
import { IconPlus, IconMinus, IconRemove } from '../../Icons/Icons';
import update from 'react-addons-update';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  removeCategory,
  updateCategories,
  updateBacklink
} from '../../../store/editStoreActions';
import lodashDebounce from 'lodash.debounce';

class Categories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openCategories: [],
      modal: false,
      activeCategory: null,
      categories: props.categories || [],
      modified: props.modified
    };

    this.updateCategoriesRedux = lodashDebounce(() => {
      this.props.updateCategories(this.state.categories);
    }, 100);

    this.updateBacklinkRedux = lodashDebounce(
      ({
        url = lodashGet(this.props, 'backlink.url', ''),
        text = lodashGet(this.props, 'backlink.text', ''),
        enabled = lodashGet(this.props, 'backlink.enabled', false)
      }) => {
        this.props.updateBacklink({
          enabled,
          url,
          text
        });
      },
      100
    );
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.modified && !nextProps.modified) {
      return {
        categories: nextProps.categories,
        modified: nextProps.modified
      };
    }
    if (prevState.categories && nextProps.categories) {
      if (prevState.categories.length !== nextProps.categories.length) {
        return {
          categories: nextProps.categories,
          modified: nextProps.modified
        };
      }
    }
    if (nextProps.modified) {
      return {
        modified: nextProps.modified
      };
    }
    return null;
  }

  updateCategories(e, categoryIndex) {
    let { value } = e.target;
    let inputId = e.target.id;
    let nameToId = this.props.categories[categoryIndex].id;
    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    }

    if (inputId === 'name') {
      nameToId = value.replace(/\s+/g, '-').toLowerCase();
    }

    const categories = this.props.categories;
    const newCategories = update(categories, {
      [categoryIndex]: { [inputId]: { $set: value }, id: { $set: nameToId } }
    });

    this.setState({ categories: newCategories });

    this.updateCategoriesRedux();
  }

  rearrangeCategories(moveFromIndex, moveToIndex) {
    const categories = this.props.categories;
    const currentCategory = categories[moveFromIndex];
    let newCategories = update(categories, {
      $splice: [[moveFromIndex, 1]]
    });

    newCategories = update(newCategories, {
      $splice: [[parseInt(moveToIndex, 10), 0, currentCategory]]
    });

    this.setState({ categories: newCategories });
    this.updateCategoriesRedux();
  }

  toggleCategory(index) {
    const openCategories = this.state.openCategories;
    const indexIsOpen = openCategories.indexOf(index) > -1;
    let newOpenCategoriesArray = openCategories;

    if (!indexIsOpen) {
      newOpenCategoriesArray[newOpenCategoriesArray.length] = index;
      this.setState({ openCategories: newOpenCategoriesArray });
    } else {
      newOpenCategoriesArray.splice(openCategories.indexOf(index), 1);
      this.setState({
        openCategories: newOpenCategoriesArray
      });
    }
  }

  toggleModal(index, type) {
    const modalOpen = !this.state.modal;
    this.setState({
      activeCategory: index,
      type
    });

    this.setState({
      modal: modalOpen
    });
  }

  toggleLookbook(categoryIndex, enabled) {
    this.mergeLookbook(categoryIndex, { enabled });
  }

  mergeLookbook(categoryIndex, lookbook) {
    const { categories } = this.state;

    const currentLookbook = categories[categoryIndex].lookbook;
    const newCategories = update(categories, {
      [categoryIndex]: {
        lookbook: {
          $set: Object.assign({}, currentLookbook, lookbook)
        }
      }
    });
    this.setState({ categories: newCategories });
    this.updateCategoriesRedux();
  }

  updateLookbook(categoryIndex) {
    return this.mergeLookbook.bind(this, categoryIndex);
  }

  render() {
    const { removeCategory, backlink } = this.props;
    const {
      openCategories,
      activeCategory: activeCategoryIndex,
      modal,
      categories = []
    } = this.state;
    const getLookbook = category => category.lookbook || {};

    return (
      <div className="sections categories">
        <BackLink
          enabled={lodashGet(backlink, 'enabled', false)}
          url={lodashGet(backlink, 'url', '')}
          text={lodashGet(backlink, 'text', '')}
          updateBacklink={this.updateBacklinkRedux}
        />

        {categories &&
          categories.map((category, categoryIndex) => {
            const isOpen = openCategories.indexOf(categoryIndex) > -1;
            return (
              <Card key={categoryIndex}>
                <CardHeader
                  className={classnames({
                    open: isOpen
                  })}
                >
                  {isOpen ? (
                    <React.Fragment>
                      <h5 className="toggle">
                        <span
                          onClick={() => this.toggleCategory(categoryIndex)}
                        >
                          <IconMinus />
                        </span>

                        <Input
                          id="name"
                          onChange={e =>
                            this.updateCategories(e, categoryIndex)
                          }
                          value={category.name || ''}
                        />
                        <small
                          onClick={() => this.toggleCategory(categoryIndex)}
                        >
                          ({category.id})
                        </small>
                      </h5>
                    </React.Fragment>
                  ) : (
                    <h5
                      className="toggle"
                      onClick={() => this.toggleCategory(categoryIndex)}
                    >
                      <IconPlus />
                      {category.name} <small>({category.id})</small>
                    </h5>
                  )}

                  <div>
                    <FormGroup inline>
                      <Input
                        title="Change category order"
                        type="select"
                        id="order"
                        bsSize="sm"
                        onChange={e =>
                          this.rearrangeCategories(
                            categoryIndex,
                            e.target.value
                          )
                        }
                        value={categoryIndex || ''}
                      >
                        {categories.map((category, index) => (
                          <option key={index} value={index}>
                            {index + 1}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                    <Button
                      color="primary"
                      onClick={() => removeCategory(categoryIndex)}
                      size="sm"
                      outline
                      title="Remove category"
                    >
                      <IconRemove />
                    </Button>
                  </div>
                </CardHeader>
                <CardBody>
                  <Collapse isOpen={openCategories.indexOf(categoryIndex) > -1}>
                    <FormGroup className="flex-100 mt-3 position-relative form-group">
                      <Label
                        for={`look-book-category-${categoryIndex}`}
                        check
                        className="switch-toggle"
                      >
                        <Input
                          type="checkbox"
                          checked={getLookbook(category).enabled}
                          onChange={e =>
                            this.toggleLookbook(categoryIndex, e.target.checked)
                          }
                          id={`look-book-category-${categoryIndex}`}
                        />
                        <div className="slider" />
                        <span>Show Look Book</span>
                      </Label>
                      <FormText color="muted">
                        Show an image Look Book with clickable hotspots, which
                        can be configured for each breakpoint.
                      </FormText>
                    </FormGroup>
                    {getLookbook(category).enabled && (
                      <LookBook
                        key={this.props.changeCount}
                        imageBasePath={this.props.imageBasePath}
                        {...getLookbook(category)}
                        onSave={this.updateLookbook(categoryIndex)}
                      />
                    )}
                    <FormGroup className="flex-100 mt-3">
                      <Label>Category description</Label>
                      <Input
                        id="description"
                        type="textarea"
                        rows="3"
                        onChange={e => this.updateCategories(e, categoryIndex)}
                        value={category.description || ''}
                      />
                    </FormGroup>
                    <FormGroup className="flex-100">
                      <Label>Recommendations category</Label>
                      <Input
                        id="recommendations"
                        onChange={e => this.updateCategories(e, categoryIndex)}
                        value={category.recommendations || ''}
                        placeholder={'e.g. Web_COMPUTER_DESKS'}
                      />
                    </FormGroup>

                    <div className="pt-2">
                      <FormGroup className="flex-100 mb-0">
                        <Label className="mb-2">Subcategories</Label>
                      </FormGroup>
                      <Subcategories categoryIndex={categoryIndex} />
                      <hr />
                      <div className="text-right">
                        <Button
                          outline
                          color="primary"
                          onClick={() =>
                            this.toggleModal(categoryIndex, 'subcategory')
                          }
                        >
                          <IconPlus />
                          <span>Add subcategory</span>
                        </Button>
                      </div>
                    </div>
                  </Collapse>
                </CardBody>
              </Card>
            );
          })}

        <div className="text-right mb-2 mt-4">
          <Button
            outline
            color="primary"
            onClick={() => this.toggleModal(null, 'category')}
          >
            <IconPlus />
            <span> Add category</span>
          </Button>
        </div>

        <CategoryModal
          isOpen={modal}
          toggle={() => this.toggleModal(null)}
          activeCategory={activeCategoryIndex}
          type={this.state.type}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ activeStore }) => ({
  categories:
    activeStore.activeStore && activeStore[activeStore.activeStore]
      ? activeStore[activeStore.activeStore].categories
      : null,
  modified: activeStore.modified,
  backlink:
    activeStore.activeStore && activeStore[activeStore.activeStore]
      ? activeStore[activeStore.activeStore].backlink
      : {}
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      removeCategory,
      updateCategories,
      updateBacklink
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Categories);



// WEBPACK FOOTER //
// ./src/components/categories/Categories/Categories.js